import type { Content } from '../types'

const postKeys = new WeakMap<object, string>()
let nextPostKey = 1

function getPostSemanticKey(content: Content): string {
  return JSON.stringify({
    text: content.text,
    images: content.images?.map((image) => image.source?.id ?? image.url),
    video: content.video?.uploadId ?? content.video?.url,
    gif: content.gif?.url,
    link: content.link?.url,
  })
}

export function getPostPreviewEntries<T>(
  posts: T[],
  getContent: (post: T) => Content,
  getIdentity?: (post: T, index: number) => object,
): Array<{ key: string; post: T }> {
  const keyOccurrences = new Map<string, number>()

  return posts.map((post, index) => {
    const content = getContent(post)
    const identity = getIdentity?.(post, index) ?? content
    let semanticKey = postKeys.get(identity)
    if (!semanticKey) {
      semanticKey = `${getPostSemanticKey(content)}:${nextPostKey++}`
      postKeys.set(identity, semanticKey)
    }
    const occurrence = (keyOccurrences.get(semanticKey) ?? 0) + 1
    keyOccurrences.set(semanticKey, occurrence)
    return { key: `${semanticKey}:${occurrence}`, post }
  })
}
